import * as formatters from '@advisr/frontend-ui-components/src/utils/formatters'

const FormattersPlugin = {
  install (Vue, options) {
    // Add formatters to Vue prototype
    Vue.prototype.$formatAOrAn = formatters.formatAOrAn
    Vue.prototype.$formatNumberWithCommas = formatters.formatNumberWithCommas
    Vue.prototype.$formatPrettyDate = formatters.formatPrettyDate
    Vue.prototype.$formatPrettyDateWithFullMonth = formatters.formatPrettyDateWithFullMonth
    Vue.prototype.$formatShortDate = formatters.formatShortDate
    Vue.prototype.$formatShortDateWithTime = formatters.formatShortDateWithTime
    Vue.prototype.$formatTime = formatters.formatTime
    Vue.prototype.$formatShortPrettyDate = formatters.formatShortPrettyDate
    Vue.prototype.$formatShortDateWith12HourTime = formatters.formatShortDateWith12HourTime
    Vue.prototype.$formatShortDateWith12HourTimeAndZone = formatters.formatShortDateWith12HourTimeAndZone
    Vue.prototype.$formatPhone = formatters.formatPhone
    Vue.prototype.$formatGoogleAddress = formatters.formatGoogleAddress
    Vue.prototype.$calculateMonthlyDuration = formatters.calculateMonthlyDuration
    Vue.prototype.$stripUtmString = formatters.stripUtmString
    Vue.prototype.$cleanUrl = formatters.cleanUrl
  }
}

export default FormattersPlugin
